// @arch:pure-engine
export function isWebUrl(value) {
  try { return ['http:', 'https:'].includes(new URL(value).protocol); } catch { return false; }
}
export function browserReadPlan(extract, selector) {
  if (extract !== 'links' && !selector) return { method: 'take_snapshot', params: {} };
  const root = selector ? `document.querySelector(${JSON.stringify(selector)})` : 'document.body';
  const value = extract === 'links'
    ? "Array.from(root.querySelectorAll('a[href]')).slice(0, 200).map(a => a.textContent.trim() + ' — ' + a.href).join('\\n')"
    : "String(root.innerText || '').slice(0, 8000)";
  return { method: 'evaluate_script', params: { function: `() => { const root = ${root}; if (!root) return 'Seletor não encontrado'; return ${value}; }` } };
}
